import { makeStyles } from "@mui/styles";

const drawerStyle = makeStyles(() => ({

    list:{
    marginLeft:"30px !important",
    paddingTop:"0px !important",
    paddingBottom:"0px !important",
    },
  listItemText: {
    "&.MuiTypography-body1": {
      fontWeight: "500 !important",
    },
  },
}));

export default drawerStyle;
